import { render, staticRenderFns } from "./custom-javascript.vue?vue&type=template&id=2f856124"
import script from "./custom-javascript.vue?vue&type=script&lang=js"
export * from "./custom-javascript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports